// KSK064 — icon keys a merchant can set on a kiosk category tab / item card
// (minty_display_category.kiosk_icon, minty_item.kiosk_icon). Same keys as
// minty.crm.api `const.kiosk_icons` and the merchant portal's
// src/config/kioskIcons.js. Value = Material Icons Round ligature; the chef
// hat has none, so KskIcon draws it from CHEF_HAT_SVG_SHAPES.
export const KIOSK_ICONS = {
  chef_hat: null,
  exclamation: "priority_high",
  star: "star",
  fire: "local_fire_department",
  thumb_up: "thumb_up",
  new: "fiber_new",
  leaf: "eco",
  heart: "favorite",
};

export const CHEF_HAT_SVG_SHAPES = [
  { tag: "circle", attrs: { cx: 7.5, cy: 10, r: 3.5 } },
  { tag: "circle", attrs: { cx: 12, cy: 7.5, r: 4.5 } },
  { tag: "circle", attrs: { cx: 16.5, cy: 10, r: 3.5 } },
  { tag: "rect", attrs: { x: 7, y: 10, width: 10, height: 6.5 } },
  { tag: "rect", attrs: { x: 7, y: 17.5, width: 10, height: 2.5, rx: 0.5 } },
];

export function isKioskIcon(key) {
  return !!key && Object.prototype.hasOwnProperty.call(KIOSK_ICONS, key);
}
